import { DictionaryEntity } from '@app/pcs/models';
import {gql} from 'apollo-angular';


export interface DossierState {
  dossierStatus: DictionaryEntity;
  dossierType: DictionaryEntity;
  processType: DictionaryEntity;
}

export const dossierState = gql`
  fragment dossierState on DossierState {
    processType {
      id
      description
    }
    dossierStatus {
      id
      description
    }
    dossierType {
      id
      description
    }
  }
`;
